import React, { memo } from "react";
import { Modal, Button, Typography } from "antd";
import { ReactComponent as ExclamationIcon } from "../../../assets/Icons/ExclamationIcon.svg";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import "./DeleteTemplateModal.scss";

const DeleteTemplateModal = ({
  isOpen,
  onClose,
  onDelete,
  templateId,
  loading,
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      className="deleteTemplateModal"
    >
      <div className="deleteModalContent">
        <ExclamationIcon />
        <h3 className="main-content">
          Are you sure you want to delete this template?
        </h3>
        <div className="deleteModalActions">
          <Button
            type="default"
            danger
            className="deleteBtn"
            loading={loading}
            onClick={onDelete}
          >
            Delete
          </Button>
          <NormalButton type="default" className="cancelBtn" onClick={onClose}>
            Cancel
          </NormalButton>
        </div>
      </div>
    </Modal>
  );
};

export default memo(DeleteTemplateModal);
